// src/components/Sections/FootSection/FooterSection.jsx
import React from 'react';
import './FooterSection.scss';

export default function FooterSection() {
  return (
    <footer className="site-footer">
      <div className="container footer__inner">
        <p>© {new Date().getFullYear()} The Tour Golfers. A Country Club Without Walls.</p>

        <nav aria-label="Footer">
          <a href="#how-it-works">How It Works</a>
          <a href="#launch">2027 Launch</a>
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms-of-service">Terms of Service</a>
          <a href="/community-guidelines">Community Guidelines</a>
          <a href="mailto:support@thetourgolfers.com">Support</a>
        </nav>
      </div>
    </footer>
  );
}